var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{ref:"userAvatar"},[_c('gl-avatar',{class:{
      lazy: _vm.lazy,
      [_vm.cssClasses]: true,
    },attrs:{"src":_vm.resultantSrcAttribute,"data-src":_vm.sanitizedSource,"size":_vm.size,"alt":_vm.imgAlt}}),_vm._v(" "),(_vm.tooltipText || _vm.$scopedSlots.default)?_c('gl-tooltip',{attrs:{"target":() => _vm.$refs.userAvatar,"placement":_vm.tooltipPlacement,"boundary":"window"}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.tooltipText))]})],2):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }